import React from "react";
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Accueil from './components/accueil.jsx';
import { InfoChaine } from './components/infoChaine.jsx'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LOCALES } from './i18nProvider';
import DetailSatellite from "./components/detailSatellite.jsx";
import Login from "./components/login";
import UploadImageBanniere from "./components/banniere/uploadImageBanniere.jsx";
import ModificationBanniere from "./components/banniere/modificationBanniere.jsx";
import Satellite from "./components/admin/satellite.jsx";

export function App() {
  const language = LOCALES.ENGLISH;
  const parsedData = window.location.pathname.split("/");
  let domain = parsedData[1];

  return (
    <Router basename={domain+ "/"}>
      <Routes>
        <Route exact path="/" element={<Accueil langue={language} />} />

        <Route path="/channel/:id" element={<InfoChaine />} />
        <Route path="/detailSatellite" element={<DetailSatellite/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/admin_uploadImage" element={<UploadImageBanniere/>} />
        <Route path="/admin_dashboardBanner" element={<ModificationBanniere/>} />
        <Route path="/admin_dashboardSatellite" element={<Satellite/>} />
      </Routes>
    </Router>
  );
}